import { IClientErrorEvent, IClientErrorParams, IClientErrorPartC, ErrorSeverity } from '@mecontrol/common';
import { ME } from '../../utilities';
import { EventMoment } from '../eventQueue';
import { createPartA, getPageTags } from '../eventGenerator';

const eventName = 'Ms.Webi.ClientError';

/**
 * Creates a ClientError event to log error details on Me Control
 * @param errorParams The object containig details of the error that occurred
 * @returns The ClientError event that was created
 */
export function createClientError(errorParams: IClientErrorParams, moment: EventMoment): IClientErrorEvent {
    let partA = createPartA(eventName, moment.date, moment.cv);

    const cleanString = (str: string) => str.replace(/\n/g, '\\n');

    let partC: IClientErrorPartC = {
        baseType: undefined,
        errorName: errorParams.name,
        errorMessage: cleanString(errorParams.details),
        errorType: errorParams.type,
        errorInfo: JSON.stringify(getPageTags(moment.accounts.counts, moment.accounts.current)),
        severity: errorParams.severity || ErrorSeverity.Error,
        wasDisplayed: errorParams.displayed,
        pageName: moment.pageName,
        impressionGuid: moment.impressionGuid,
        market: ME.Config.mkt
    };

    return {
        partA,
        partB: undefined,
        partC
    };
}
